import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Divider, Radio } from 'antd';
import React from 'react';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

interface IConfirmConditionComponentProps {
  valueConfirmComponentCondition: boolean;
  titleRadioYes: string;
  titleRadioNo: string;
  handleConfirmConditionChange: Function;
};

interface IConfirmConditionComponentStateType {

};

export default class ConfirmConditionComponent extends React.Component<IConfirmConditionComponentProps, IConfirmConditionComponentStateType> {

  constructor(props: IConfirmConditionComponentProps) {
    super(props);
    this.state = {
    };
  }
  render() {
    return (
      <Wrapper>
        <div>
          <span style={{ marginRight: ' 5px' }}>{I18n.l("formflow.labels.confirmCondition")}</span>
          <RadioGroup onChange={this.props.handleConfirmConditionChange()} defaultValue={this.props.valueConfirmComponentCondition}>
            <RadioButton style={this.props.valueConfirmComponentCondition === undefined ? { borderColor: `${Theme.secondary.red}` } : {}} value={true}>{(this.props.titleRadioYes).toUpperCase()}</RadioButton>
            <RadioButton style={this.props.valueConfirmComponentCondition === undefined ? { borderColor: `${Theme.secondary.red}` } : {}} value={false}>{(this.props.titleRadioNo).toUpperCase()}</RadioButton>
          </RadioGroup>
          <div style={{paddingLeft:' 205px', fontWeight: 'bold', color: `${Theme.secondary.red}`}} >{this.props.valueConfirmComponentCondition === undefined && I18n.l("form.validation.field.required")}</div>
        </div>
        <Divider />
      </Wrapper>
    );
  }
}


const Wrapper = styled.div`
.validation{
  border-color: ${Theme.secondary.red};
}
        
`
